import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {FirstLoginGuard} from './first-login.guard';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotFirstLoginGuard  {
  private router = inject(Router);
  private firstLoginGuard = inject(FirstLoginGuard);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    //Invert the first time user guard if it's a simple boolean result
    //If it's a URL tree, just pass that along
    return this.firstLoginGuard.canActivate(next, state).pipe(map((firstTimeUser: boolean | UrlTree) => {
      if(typeof firstTimeUser === 'boolean') {
        return !firstTimeUser || this.router.parseUrl('/consumer-services');
      } else {
        //UrlTree, which would point to the first time user page.  So we'll simply convert that to true to avoid an infinite redirection loop.
        return true;
      }
    }));
  }

}
